import { css } from '@emotion/react';
import React from 'react';
import { useDispatch } from 'react-redux';

import { AUTH_REQUEST } from './redux/auth';
import { loading } from './assets/styles/loading';
import { useAppSelector } from './hooks';

const accessDeniedStyles = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  text-align: center;
  background-color: #f5f5f5;
`;

const messageStyles = css`
  font-size: 28px;
  font-weight: 600;
  color: #333;
  margin-bottom: 16px;
`;

const descriptionStyles = css`
  font-size: 18px;
  color: #666;
  max-width: 500px;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const linkStyles = css`
  font-size: 18px;
  color: #00a0dc;
  text-decoration: none;
  font-weight: 500;
  &:hover {
    text-decoration: underline;
  }
`;

const App = () => {
  const { me, jwt, error } = useAppSelector(state => state.auth);
  const dispatch = useDispatch();

  if (!jwt) {
    dispatch({ type: AUTH_REQUEST });
    return (
      <div css={loading}>
        <img
          alt="spinner"
          src="https://www.warbyparker.com/assets/img/icons/actions/spinner.png"
        />
        <p>Loading&hellip;</p>
      </div>
    );
  }

  if (!me) {
    return (
      <div css={loading}>
        <img
          alt="spinner"
          src="https://www.warbyparker.com/assets/img/icons/actions/spinner.png"
        />
        <p>Loading&hellip;</p>
      </div>
    );
  }

  if (error) {
    return <h1>{error}</h1>;
  }

  // App is decommissioned - show access denied message to all users
  return (
    <div css={accessDeniedStyles}>
      <div css={messageStyles}>This application is no longer available</div>
      <div css={descriptionStyles}>
        Please use{' '}
        <a
          href="https://pmp.warbyparker.com/appointments"
          css={linkStyles}
          target="_blank"
          rel="noopener noreferrer"
        >
          https://pmp.warbyparker.com/appointments
        </a>
        {' '}to issue prescriptions and view appointment.
      </div>
    </div>
  );
};

export default App;
